import React, {useEffect, useState} from "react";
import {Link, useHistory} from "react-router-dom";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Card from "@material-ui/core/Card";
import Box from "@material-ui/core/Box";
import {useSelector} from "react-redux";

import LoginForm from "../../components/Forms/Login";
import {useMediaQuery} from "@material-ui/core";
import {useTheme} from "@material-ui/core/styles";
import {RootState, useAppDispatch} from "../../redux/store";
import {ReactComponent as LogoSVG} from "../../assets/logo.svg";
import ConfirmEmail from "../../components/ConfirmEmail/ConfirmEmail";

const useStyles = makeStyles({
  cardRoot: {
    width: "100%",
    padding: 40,
    marginBottom: 32,
  },
  containerRoot: {
    position: "relative",
    zIndex: 1,
  },
});


const Login = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const [isEmailConfirmed, setIsEmailConfirmed] = useState(undefined);

  return (
      <Container className={classes.containerRoot} maxWidth="sm">
        <Card className={classes.cardRoot} style={{paddingBottom: "40px", marginTop: "100px"}}>
          {isEmailConfirmed === false
              ?
              <ConfirmEmail />
              :
              <>
                <Box margin={isMobile ? "0" : "35px 0"}>
                  <Typography
                      variant="h2"
                      align="center"
                  >
                    Welcome back!
                  </Typography>
                </Box>
                <LoginForm setIsEmailConfirmed={setIsEmailConfirmed}/>
              </>}
        </Card>
        <Typography align="center" style={{fontSize: "20px"}}>
          Don’t have an account? <Link to="/signUp">Sign Up!</Link>
        </Typography>

      </Container>
  );
};

export default Login;
